import { useMediumScreen } from '@/hooks'
import illustration from '@/images/airdrop-external-link-illustration.svg'
import { Box, Button, Group, Modal, Space, Text, Title } from '@mantine/core'
import Image from 'next/image'
import React, { useState } from 'react'

interface AirdropTaskExternalLinkButtonProps {
  url: string
  description: string
  isLoading?: boolean
  children: React.ReactNode
}

const AirdropTaskExternalLinkButton: React.FC<AirdropTaskExternalLinkButtonProps> = ({
  url,
  description,
  isLoading,
  children
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const [isRedirecting, setIsRedirecting] = useState(false)

  const { isMediumScreen } = useMediumScreen()

  const handleOpen = () => {
    setIsModalOpen(true)
  }

  const handleClose = () => {
    setIsModalOpen(false)
  }

  const handleContinue = () => {
    setIsRedirecting(true)
  }

  return (
    <>
      <Button fullWidth={!isMediumScreen} onClick={handleOpen} loading={isLoading || isModalOpen}>
        {children}
      </Button>

      <Modal opened={isModalOpen} onClose={handleClose} size="xl">
        <Group spacing={0} pb="xl">
          <Box pl={64} pr={64}>
            <Image src={illustration} alt="Airdrop external url illustration" />
          </Box>

          <Box sx={{ maxWidth: 320 }}>
            <Title order={4} sx={{ lineHeight: 1 }}>
              Come back soon!
            </Title>

            <Space h="xs" />

            <Text sx={(t) => ({ color: t.colors.gray[7] })}>{description}</Text>

            <Space h="md" />

            <Group spacing="xs">
              <Button variant="outline" color="dark" onClick={handleClose}>
                Back to Stride
              </Button>

              <Button component="a" href={url} target="_blank" loading={isRedirecting} onClick={handleContinue}>
                Continue
              </Button>
            </Group>
          </Box>
        </Group>
      </Modal>
    </>
  )
}

export { AirdropTaskExternalLinkButton }

